import { useQuery } from '@tanstack/react-query';
import type { SystemLogToken } from '@sleed/bizcommerce-api';
import { systemLogApi } from '~/lib/api/client';

export const systemLogKeys = { all: ['system-log'] as const, list: () => [...systemLogKeys.all, 'list'] as const };

/** Read-only system log list (legacy `/systemlog/getall`). */
export function useSystemLogList() {
	return useQuery<SystemLogToken[]>({
		queryKey: systemLogKeys.list(),
		queryFn: async () => (await systemLogApi.getAll()).data.items ?? []
	});
}
